var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "nti-shop-filter-container" },
    [_c("ShopFilter")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }